import {
  Form,
  Button,
  Typography,
  SelectInput,
  ButtonsWrapper,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IPermissionGroup } from 'src/pages/settings/components/permission-group/permission-group.interfaces';

import { WarningContainer, HeaderContainer } from './change-permission-group.styles';
import { IManager, IChangePermissionProps } from './change-permission-group.interfaces';

const ChangePermissionGroup: FC<IChangePermissionProps> = ({
  permissionGroupId,
  isCloseGroupModalAttempt,
  closeChangeModalAttempt,
}) => {
  const { t } = useTranslation(['common', 'settings']);

  const [accountsRelations, setAccountsRelations] = useState<{ [key: string]: string }>({});
  const permissionsGroups: any[] = [];
  const managers: any[] = [];

  const onGroupSelect = (accountId: string) => (selectedPermissionGroupId: string) => {
    setAccountsRelations(prevData => ({ ...prevData, [accountId]: selectedPermissionGroupId }));
  };

  const saveIsDisabled =
    !managers.length || managers.length !== Object.values(accountsRelations).length;

  return (
    <>
      <HeaderContainer>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {t('settings:permissionGroupSettings.labels.addNewPermissionGroupForUser')}
        </Typography>
        <Typography>
          {t('settings:permissionGroupSettings.labels.numberOfUsers')}:
          <span>{managers.length}</span>
        </Typography>
      </HeaderContainer>
      {isCloseGroupModalAttempt && (
        <WarningContainer>
          <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.tone.red}>
            {t('settings:permissionGroupSettings.notifications.closeWindow')}
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t('settings:permissionGroupSettings.notifications.subCloseWindow')}
          </Typography>
        </WarningContainer>
      )}
      <Form layout="vertical" onFinish={() => {}}>
        {managers.map(({ _id: accountId, displayName }: IManager) => (
          <Form.Item label={displayName} key={accountId}>
            <SelectInput
              value={accountsRelations[accountId]}
              onChange={onGroupSelect(accountId)}
              placeholder={t('settings:permissionGroupSettings.placeholders.choosePermissionGroup')}
            >
              {permissionsGroups.map(({ _id: id, name }: IPermissionGroup) => (
                <SelectInput.Option key={id} value={id}>
                  {name}
                </SelectInput.Option>
              ))}
            </SelectInput>
          </Form.Item>
        ))}
        <ButtonsWrapper marginTop={14}>
          <Button type="primary" htmlType="submit" disabled={saveIsDisabled}>
            {t('common:buttons.save')}
          </Button>
          <Button onClick={() => closeChangeModalAttempt()}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </>
  );
};

export default ChangePermissionGroup;
